// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iDlBk","questions":"styles_questions__25wNS","footer":"styles_footer__3Nyce"};